var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-icon",
    clipPath: "url(#clip0_7529_1456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download-icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 13.5C23.6642 13.5 24 13.8358 24 14.25V18.75C24 21.5971 22.4982 24 20.4375 24H3.5625C1.50183 24 0 21.5971 0 18.75V14.25C0 13.8358 0.335786 13.5 0.75 13.5C1.16421 13.5 1.5 13.8358 1.5 14.25V18.75C1.5 20.8735 2.51657 22.5 3.5625 22.5H20.4375C21.4834 22.5 22.5 20.8735 22.5 18.75V14.25C22.5 13.8358 22.8358 13.5 23.25 13.5ZM12 0C12.4142 0 12.75 0.335786 12.75 0.75V14.364L15.9706 11.1562C16.2415 10.8863 16.667 10.8663 16.9608 11.0956L17.0313 11.1581C17.3237 11.4516 17.3228 11.9264 17.0294 12.2188L12.5294 16.7023C12.2367 16.9939 11.7633 16.9939 11.4706 16.7023L6.97064 12.2188C6.67721 11.9264 6.67634 11.4516 6.9687 11.1581C7.26105 10.8647 7.73593 10.8638 8.02936 11.1562L11.25 14.3655V0.75C11.25 0.335786 11.5858 0 12 0Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7529_1456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e551b35fd6fc09b65822f531971f661a.svg";
export { ForwardRef as ReactComponent };